import {
    BehaviorSubject,
    distinctUntilChanged,
    filter,
    map,
    merge,
    switchMap,
} from "rxjs";

import { ProductIdManagerInterface } from "./ProductIdManagerInterface";
import { ProductIdProviderInterface } from "./ProductIdProviderInterface";

export class ProductIdManager implements ProductIdManagerInterface {
    providers$ = new BehaviorSubject<ProductIdProviderInterface[]>([]);
    productId$ = new BehaviorSubject<number | null>(null);

    constructor() {
        this.providers$
            .pipe(
                map((providers) =>
                    providers.map((provider) => provider.selectProductId())
                ),
                switchMap((productIdObservables) =>
                    merge(...productIdObservables)
                ),
                filter((value) => value !== null),
                distinctUntilChanged()
            )
            .subscribe(this.productId$);
    }

    public registerProvider(provider: ProductIdProviderInterface): void {
        this.providers$.next([...this.providers$.getValue(), provider]);
    }

    public unregisterProvider(provider: ProductIdProviderInterface): void {
        const providers = this.providers$.value;

        const newProviders = providers.filter((item) => item !== provider);
        if (newProviders.length === 0) {
            this.productId$.next(null);
        }

        this.providers$.next(newProviders);
    }
}
